import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card as UiCard,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@crisp/crisp-ui/cabbage';
import { Icon } from './Icon';
import styles from './Card.module.css';

export interface CardProps {
  title?: string;
  icon?: string;
  href?: string;
  children?: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({
  title,
  icon,
  href,
  children,
  className = '',
}) => {
  // Cabbage composes the description inside the header (composition.md); in a
  // CardContent of its own it picks up both paddings and floats away from the
  // title.
  const body = (
    <UiCard className={`${styles.card} ${className}`.trim()}>
      <CardHeader>
        {icon && (
          <div className={styles.icon}>
            <Icon name={icon} />
          </div>
        )}
        {title && <CardTitle>{title}</CardTitle>}
        {children ? <CardDescription>{children}</CardDescription> : null}
      </CardHeader>
    </UiCard>
  );

  if (!href) return body;

  const isExternal =
    href.startsWith('http://') ||
    href.startsWith('https://') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:');

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={styles.link}>
        {body}
      </a>
    );
  }

  if (href.startsWith('#')) {
    return (
      <a href={href} className={styles.link}>
        {body}
      </a>
    );
  }

  return (
    <Link to={href} className={styles.link}>
      {body}
    </Link>
  );
};

export default Card;
